const pingInterval = 5000;

class PopupPinger {
  #interval = null;

  stopPing = () => clearInterval(this.#interval);

  startPing = (popup, paths) => {
    this.stopPing();

    const message = { type: 'ping' };

    this.#interval = setInterval(() => {
      paths.forEach((path) => popup.postMessage(message, path));
    }, pingInterval);
  };
}


export default new PopupPinger();
